import GenericCatalogPage from "./GenericCatalogPage";
import { Map } from "lucide-react";

export default function Areas() {
  return (
    <GenericCatalogPage
      title="Áreas"
      description="Administre las áreas del laboratorio"
      icon={Map}
      apiKey="areas"
      testIdPrefix="area"
    />
  );
}
